import type { NcIconProps } from "./nc-icon";
import { NcIcon } from "./nc-icon";

const NcIconHomeModern = (props: NcIconProps) => (
  <NcIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M20 10.75V21h-7.5v-4.875c0-.621-.504-1.125-1.125-1.125h-2.25C8.504 15 8 15.504 8 16.125V21m4.5 0H17V3.545M2 9l4.5-1.636L17 3.545 18.5 3m1.5 7.75-3-1m3 1 1.5.5M2 21h1.5m0 0h18m-18 0V3h3v4.364"
    />
  </NcIcon>
);
export { NcIconHomeModern };
